import { type SitemapQueryResult } from '@tac/sanity-client/types';
import type { LinkListItem } from '@/components/link-list';

const isNestedSafetyFeaturePage = (pathname: string | null): boolean => {
  return pathname?.startsWith('/safety-features/') ?? false;
};

export const groupSafetyFeatureLinks = (pages: SitemapQueryResult) => {
  const result: LinkListItem[] = [];
  const safetyFeaturePages: LinkListItem[] = [];

  pages.forEach((page) => {
    if (page.pathname === null || !page.title) {
      return;
    }

    if (page.pathname?.startsWith('/safety-features/')) {
      // This is a safety feature page, collect for grouping but don't add to main result yet
      safetyFeaturePages.push({
        title: page.title,
        url: page.pathname,
      });
    } else if (page.pathname !== '/safety-features') {
      // This is a regular page (but not the main safety features page), add in original position
      result.push({
        title: page.title,
        url: page.pathname,
      });
    }
    // Skip the main safety features page - it won't be included in the result
  });

  // Insert the Safety Features group at the appropriate position
  // Find where to insert it based on the original order
  const insertIndex = pages.findIndex((page) => isNestedSafetyFeaturePage(page.pathname));

  if (safetyFeaturePages.length > 0) {
    const safetyFeaturesGroup = {
      title: 'Safety Features',
      url: '/safety-features',
      children: safetyFeaturePages,
    };
    result.splice(insertIndex, 0, safetyFeaturesGroup);
  }

  return result;
};
